import { Classifier } from '../interfaces/Classifier'

export function convertToClassifierStatus(classifiers: Classifier[]) {
  return classifiers.map(({ nosaukums, kods }: Classifier) => ({ nosaukums, kods }))
}
